<forge-date-picker [formControl]="formControl" masked [min]="min" [max]="max">
  <forge-text-field [required]="isRequired" [invalid]="isInvalid" density="small">
    <input type="text" #input>

    @if (!hideLabel) {
      <label slot="label">{{label}}</label>
    }

    <span slot="support-text">
      @if (hasError('required')) {
        {{label}} is required
      }

      @if (hasCustomValidators) {
        @for (customError of customErrors; track customError) {
          <ng-container slot="support-text">
            @if (hasError(customError.errorKey)) {
              {{customError.message}}
            }
          </ng-container>
        }
      }
    </span>
  </forge-text-field>
</forge-date-picker>